<template>
  <vs-popup
    :title="getTitle()"
    @onClose="handleOnClose"
    :active.sync="showThisPopup"
    class="stop-bookings-popup"
  >
    <div v-if="venueNote">
      <p class="mb-1 text-sm text-gray-500">
        Reason for {{ isOnlineBookingClosed ? "starting" : "stopping" }} online
        bookings today:
      </p>
      <textarea
        v-model="venueNote.message"
        type="text"
        class="
          mb-2
          rounded-lg
          w-full
          h-16
          focus:outline-none
          border border-gray-200
          focus:ring focus:border-blue-300
          p-2
        "
      >
      </textarea>
    </div>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        class="mr-2"
        :color="isOnlineBookingClosed ? 'success' : 'danger'"
        :disabled="!validForm"
        @click="handleSaveClick"
        >{{
          isOnlineBookingClosed ? "Start bookings" : "Stop bookings"
        }}</vs-button
      >
      <vs-button type="border" color="primary" @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import moment from "moment";
import { VenueNote } from "../../../../store/modules/marcom/data-model/venue-notes/venue-note";
import { PatchVenueBookingsClosedNoteCommand } from "../../../../store/modules/marcom/data-model/venue-notes/queries-and-commands/patch-venue-bookings-closed-note-command";

export default {
  components: {},
  data() {
    return {
      showThisPopup: false,
      venueNote: undefined,
      date: undefined,
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
      isOnlineBookingClosed: "marcom/isOnlineBookingClosed",
    }),
    validForm() {
      return this.venueNote && this.venueNote.isValid();
    },
    userName() {
      let username = "Unknown user";
      if (this.$AuthService.isAuthenticated()) {
        username = this.$AuthService.getUser().name
        }
      return username;
    },
  },
  methods: {
    show(date) {
      const utcDate = moment.utc(date.format("YYYY-MM-DD")).toJSON();
      this.date = utcDate;
      this.venueNote = new VenueNote(
        utcDate,
        this.activeVenueDetails.venueDetailsId
      );
      this.showThisPopup = true;
    },
    getTitle() {
      if(!this.activeVenueDetails) return undefined;

      let title = `${
        this.isOnlineBookingClosed ? "Start bookings" : "Stop bookings"
      } for ${this.activeVenueDetails.name} on ${this.formatPopupDate()}`;
      return title;
    },
    async handleSaveClick() {
      try {
        this.$vs.loading();

        const command = new PatchVenueBookingsClosedNoteCommand(
          this.venueNote.date,
          this.venueNote.venueDetailsId,
          !this.isOnlineBookingClosed,
          `${this.isOnlineBookingClosed ? 'Started:' : 'Closed:'} ${this.venueNote.message} - ${this.userName}, ${moment(new Date).format("HH:mm")}`
        );
        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.UpdateVenueBookingsClosedNote,
          command
        );

        this.handleOnClose();
      } catch (err) {
        console.error(err);
        throw err;
      } finally {
        this.$vs.loading.close();
      }
    },
    handleOnClose() {
      this.venueNote = undefined;
      this.showThisPopup = false;
    },
    formatPopupDate() {
      let noteMoment = moment.utc(this.date);
      if (!noteMoment.isValid) return;
      return noteMoment.format("DD-MM-YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.stop-bookings-popup::v-deep .vs-popup {
  width: 1080px;
}
</style>
